import { SxProps, Theme } from '@mui/material';

export const headerCommonPanelSX: Record<string, (theme: Theme) => SxProps<Theme>> = {
	popperContainer: (theme: Theme) => ({
		width: '385px',
		boxShadow: `${theme.palette.grey[100]} 0 3px 6px`,
		maxHeight: '75vh',
		overflow: 'auto',
		backgroundColor: 'white',
		zIndex: '1200',
	}),
	drawerContainer: () => ({
		marginBottom: '60px',
	}),
};
